const root = 'UserDeleteAccountForm'

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  submitButton: `${root}-submitButton`,
  requestedActionText: `${root}-requestedActionText`,
}
